import React, { FC, memo, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import IconLike from '@ucheba/ui/icons/icon__like_finger.svg'
import IconDislike from '@ucheba/ui/icons/icon__dislike_finger.svg'
import IconChat from '@ucheba/ui/icons/icon__chat.svg'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { questionsThunks } from '@ucheba/store/questions'
import { feedbacksThunks } from '@ucheba/store/feedbacks'
import { authSelectors } from '@ucheba/store/auth'
import { useAuthHref } from '@ucheba/utils/hooks/useAuthHref'
import { useRouter } from 'next/router'
import { EFormType, IControlsProps } from '../types'

const Container = styled.div`
  display: flex;
  column-gap: 16px;
`

const Controls: FC<IControlsProps> = ({
  id,
  voteStats,
  type,
  onAnswerClick,
  listLength,
  rootId,
  rootType,
  limit,
  offset = 0,
}) => {
  const dispatch = useDispatch()
  const isAuth = useSelector(authSelectors.isValidToken)
  const { push } = useRouter()

  const limitItems = useMemo(() => {
    if (typeof limit === 'number') {
      return limit
    }
    return listLength
  }, [limit, listLength])

  const authHref = useAuthHref()

  const handleRate = useCallback(
    async (isUseful: boolean) => {
      if (!isAuth) {
        push(authHref)

        return
      }

      switch (type) {
        case EFormType.questions || EFormType.responsesQuestions:
          await dispatch(questionsThunks.rate({ data: { isUseful, id, type: rootType } }))

          await dispatch(
            questionsThunks.fetch({
              data: { id: rootId, limit: limitItems, type: rootType, offset },
            })
          )
          break

        case EFormType.feedbacks || EFormType.responsesFeedbacks:
          await dispatch(feedbacksThunks.rate({ data: { isUseful, id, type: rootType } }))

          await dispatch(
            feedbacksThunks.fetch({
              data: { id: rootId, limit: limitItems, type: rootType, offset },
            })
          )
          break

        default:
      }
    },
    [dispatch, id, rootId, listLength, type, rootType, offset, limit]
  )

  return (
    <Container>
      <Button
        StartIcon={<IconLike width='20px' height='20px' style={{ marginRight: -5 }} />}
        size='small'
        view='link'
        onClick={() => handleRate(true)}
      >
        <Text fontSize='h5' lineHeight='h2'>
          {`Полезно • ${voteStats?.usefulCount}`}
        </Text>
      </Button>

      <Button
        StartIcon={<IconDislike width='20px' height='20px' style={{ marginRight: -5 }} />}
        size='small'
        view='link'
        onClick={() => handleRate(false)}
      >
        <Text fontSize='h5' lineHeight='h2'>
          {`Бесполезно • ${voteStats?.notUsefulCount}`}
        </Text>
      </Button>

      <Button
        StartIcon={<IconChat width='20px' height='20px' style={{ marginRight: -5 }} />}
        size='small'
        view='link'
        onClick={onAnswerClick}
      >
        Ответить
      </Button>
    </Container>
  )
}

export default memo(Controls)
